import { ITotrace } from '../../models/totrace.interface';

export interface ITotraceState {
    totrace: ITotrace;
}

export const initialTotRaceState: ITotraceState = {
    totrace: null
};
